import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import pako from 'pako';
import { Observable } from 'rxjs';

@Injectable()
export class HttpCompressionInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (typeof req.body === 'string' && req.body.length > 1024) {
            const headers = req.headers.set('Content-Encoding', 'gzip').set('Content-Type', 'application/json;charset=utf-8');
            //req.headers.set('Content-Type', 'application/octet-stream');
            req = req.clone({ body: pako.gzip(req.body).buffer, headers });
        }
        return next.handle(req);
    }
}
